class TextWithImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('hh-image-carousel');
    this.descriptionContainer = this.querySelector('[data-description-container]');
    this.slides = this.querySelectorAll('.slide');
    this.defaultDescription = this.descriptionContainer.innerHTML;
    
    this.handleSlideChange = this.handleSlideChange.bind(this);
  }

  connectedCallback() {
    if (!this.carousel || !this.descriptionContainer) return;
    
    // Watch for scroll events on the carousel's slides container
    const slidesContainer = this.carousel.shadowRoot.querySelector('.slides');
    if (slidesContainer) {
      slidesContainer.addEventListener('scroll', this.handleSlideChange);
    }
  }

  disconnectedCallback() {
    const slidesContainer = this.carousel?.shadowRoot?.querySelector('.slides');
    if (slidesContainer) {
      slidesContainer.removeEventListener('scroll', this.handleSlideChange);
    }
  }

  handleSlideChange() {
    if (!this.carousel || !this.descriptionContainer) return;

    // Get the current slide index from the carousel
    const slidesContainer = this.carousel.shadowRoot.querySelector('.slides');
    if (!slidesContainer || !this.slides.length) return;

    // Calculate current slide index based on scroll position
    const slideWidth = this.slides[0].clientWidth;
    const currentIndex = Math.round(slidesContainer.scrollLeft / slideWidth);
    const currentSlide = this.slides[currentIndex];

    if (currentSlide) {
      const slideText = currentSlide.getAttribute('data-text');
      if (slideText) {
        this.descriptionContainer.innerHTML = slideText;
      } else {
        this.descriptionContainer.innerHTML = this.defaultDescription;
      }
    }
  }
}

customElements.define('text-with-image-carousel', TextWithImageCarousel);